import { render } from "./Evaluation5.vue?vue&type=template&id=fb1ad954"
import script from "./Evaluation5.vue?vue&type=script&lang=js"
export * from "./Evaluation5.vue?vue&type=script&lang=js"
script.render = render

export default script